import { RadioCard } from '@noorden-insurtech/alba-design-system';
import type { TFieldContext } from '../types';

export type RadioButtonOption = {
  value: string;
  label: string;
  description?: string;
};

export type RadioButtonGroupProps = {
  label: string;
  options: RadioButtonOption[];
};

export function createRadioButtonGroup(useFieldContext: () => unknown) {
  return function RadioButtonGroup({ label, options }: RadioButtonGroupProps) {
    const field = useFieldContext() as TFieldContext<string>;

    return (
      <div className='space-y-3'>
        <label className='text-sm font-medium text-alba-gray-900'>
          {label}
        </label>
        <RadioCard.Root
          value={field.state.value || ''}
          onValueChange={details => field.handleChange(details.value || '')}
        >
          <div className='flex gap-4'>
            {options.map(option => (
              <RadioCard.Item key={option.value} value={option.value}>
                <RadioCard.ItemControl />
                <RadioCard.ItemText>{option.label}</RadioCard.ItemText>
              </RadioCard.Item>
            ))}
          </div>
        </RadioCard.Root>
      </div>
    );
  };
}
